export const FaqBta = [
  {
    'title':'How long before my FIXED TERM FUNDING is paid off?',
    'content':'Your Fixed Term Funding is typically paid off over a 3, 6, 9 or 12-month period, depending on the term you selected when accepting the offer. You can view your remaining term and balance at any time via the platform.'
  },
  {
    'title':'What is my repayment projection?',
    'content':'Your repayment projection outlines your monthly repayment amounts, including any applicable fees. It’s based on the loan amount and term. You will receive a full repayment schedule at the time of approval, and you can also request it at any point during the loan term.'
  },
  {
    'title':'How do my repayments work?',
    'content':'Repayments are automatically deducted from your linked business bank account on a monthly basis. You will receive reminders ahead of each debit, and we recommend ensuring funds are available to avoid missed payments.'
  }
];